import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card bg-transparent" }
const _hoisted_2 = { class: "card-header p-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Sanciones ", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat fs-2 me-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus fs-2 me-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square" }, null, -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Evento", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "N° de sanción", -1)
const _hoisted_11 = { class: "break-word" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Fecha de inicio", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Fecha de termino", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Asunto", -1)
const _hoisted_15 = { class: "break-word" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Estado", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Registrado", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-date" }, null, -1)
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddEdit = _resolveComponent("AddEdit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.listSantions.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getSanctions && _ctx.getSanctions(...args))),
                class: "btn btn-sm btn-success me-3"
              }, [
                _hoisted_5,
                _createTextVNode("Refrescar")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRegister && _ctx.onRegister(...args)))
          }, [
            _hoisted_6,
            _createTextVNode("Registrar")
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["card-body shadow", _ctx.listSantions.length>0 ? 'bg-transparent p-0' : 'bg-white'])
      }, [
        (_ctx.listSantions.length>0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.listSantions,
              border: "",
              "table-layout": 'auto'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  width: "50",
                  label: "N°"
                }),
                _createVNode(_component_el_table_column, { width: "50" }, {
                  default: _withCtx((props) => [
                    _createVNode(_component_el_popover, {
                      effect: "light",
                      trigger: "hover",
                      placement: "left",
                      width: "300",
                      title: "Detalle de sanción"
                    }, {
                      reference: _withCtx(() => [
                        _hoisted_7
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("p", null, _toDisplayString(props.row.event_name), 1),
                          _hoisted_10,
                          _createElementVNode("p", _hoisted_11, _toDisplayString(props.row.num_resolution), 1),
                          _hoisted_12,
                          _createElementVNode("p", null, _toDisplayString(props.row.startdate), 1),
                          _hoisted_13,
                          _createElementVNode("p", null, _toDisplayString(props.row.endate), 1),
                          _hoisted_14,
                          _createElementVNode("p", _hoisted_15, _toDisplayString(props.row.message), 1),
                          _hoisted_16,
                          _createElementVNode("p", null, _toDisplayString(props.row.status_name), 1),
                          _hoisted_17,
                          _createElementVNode("p", null, [
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(props.row.user_create) + " | ", 1),
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(props.row.created_at), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "num_resolution",
                  label: "SANCIÓN",
                  width: "auto"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate",
                  label: "INICIA",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "endate",
                  label: "N° TERMINA",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  label: "ESTADO",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge badge-light-${scope.row.status_class} border border-${scope.row.status_class}`)
                    }, _toDisplayString(scope.row.status_name), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "80",
                  label: "OP",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "Editar",
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-pencil-square fs-2 text-hover-primary me-4",
                            onClick: ($event: any) => (_ctx.onEdit(scope.row))
                          }, null, 8, _hoisted_21)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "Eliminar",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-trash fs-2 text-hover-danger",
                            onClick: ($event: any) => (_ctx.onDelete(scope.row))
                          }, null, 8, _hoisted_22)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "No hay información para mostrar"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: _ctx.getSanctions
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Volver a intentar")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
      ], 2)
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_AddEdit, {
      idperson: _ctx.idperson,
      onResponse: _ctx.response,
      item: _ctx.rowItem
    }, null, 8, ["idperson", "onResponse", "item"])
  ], 64))
}